export default "__VITE_ASSET__Bi7oGXBL__"